module.exports = __webpack_public_path__ + "img/cases-brand-maxam-3.46d83201.jpg";